import GetLeadAttributes from "../api/GetLeadAttributes";
import ContactLeadAttributeModel from "../interfaces/ContactLeadAttributeModel";
import FormStateParams from "../../form-editor/interfaces/FormStateParams";
import SubscriptionsStateParams from "../../subscription-editor/interfaces/SubscriptionsStateParams";
import { EntityType } from "../enums/EntityType";
import GetContactAttributes from "../api/GetContactAttributes";
import { setModel, resetModels, ModelKey } from "../store/ModelsSlice";
import store from "../store/Store";

let o: any;

const modelConfig: Record<string, ModelKey> = {
  email: "email",
  text: "text",
  textArea: "textArea",
  url: "url",
  date: "date",
  dateTime: "dateTime",
  money: "money",
  integer: "integer",
  decimal: "decimal",
  phone: "phone",
  list: "list",
  multiList: "multiList",
  boolean: "boolean",
};

function mapModelData(fieldType: string, data: any[]) {
  if (["list", "multiList", "boolean"].includes(fieldType)) {
    return data.map((c) => ({ value: c.schemaName, text: c.displayName }));
  }
  return data.map((c) => ({ value: c.schemaName, text: c.displayName, length: c.length }));
}

function SetModels(
  data: any,
  fieldType: string,
  choicesCallback: any,
  routeParams: FormStateParams | SubscriptionsStateParams,
  entityType: EntityType,
) {
  if (!data || data.length < 1) {
    choicesCallback([{}]);
    return;
  }
  const model = modelConfig[fieldType];
  if (model) {
    const result = mapModelData(fieldType, data);
    store.dispatch(setModel({ model, key: entityType, value: result }));
    choicesCallback(result, fieldType === "boolean" ? entityType : undefined);
  }
}

function getModelFromStore(fieldType: string, entityType: EntityType) {
  const { models } = store.getState();
  const key = modelConfig[fieldType];
  return key && (models as any)[key]?.[entityType];
}

function SetMapperAttributes(
  fieldType: string,
  choicesCallback: any,
  routeParams: FormStateParams | SubscriptionsStateParams,
  entityType: EntityType = EntityType.Lead,
  obj: any = null,
) {
  o = obj || null;
  const model = getModelFromStore(fieldType, entityType);
  if (model) {
    choicesCallback(model, fieldType === "boolean" ? entityType : undefined);
    return;
  }
  const apiCall = entityType === EntityType.Lead ? GetLeadAttributes : GetContactAttributes;
  apiCall(routeParams, fieldType)
    ?.then((data: [ContactLeadAttributeModel]) =>
      SetModels(data, fieldType, choicesCallback, routeParams, entityType),
    )
    .catch(() => {
      o?.clearErrors();
      o?.addError("Server error while loading mappings.");
    });
}

export function ClearMapperAttributes() {
  store.dispatch(resetModels());
}

export default SetMapperAttributes;
